import { message } from 'antd'
import { NoticeType } from 'antd/es/message/interface'

export function createMessage(type: NoticeType, content: string) {
  message.open({ type, content, duration: 10 })
}
